import { collectionApiClient } from '@api/clients';
import { useQuery, UseQueryResult } from 'react-query';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const fetchCollectionsCount = async (params?): Promise<number> => {
  const { data } = await collectionApiClient.collectionsCountGet({ params });

  // TODO: fix count endpoint swagger schema
  return data as unknown as number;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useCollectionsCount = (params?): UseQueryResult<number> => {
  return useQuery(['collections-count', params], () => fetchCollectionsCount(params));
};
